module.exports = __webpack_public_path__ + "static/media/sample.7fb97e87.csv";